/* Iceberg-ui */
import { Box, Flex, InputRadio, Text } from '@auviknetworks/iceberg-ui';

/* MUI */
import { Grid } from '@mui/material';
import { useTheme } from '@mui/material/styles';

/* Components */
import { IntegrationCard } from 'application/Home/Partner/Integrations/Pages/Components/IntegrationCard';

/* Helpers */
import { getIntegrationsData } from 'application/Home/Partner/Integrations/Pages/Helpers/utils';

/* Shared */
import { TooltipQ } from 'application/Shared/Components/Tooltips';
import { FontSizes } from 'application/Shared/Constants';

/* React */
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const DeployAgentSelectStep = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const [hasRMM, setHasRMM] = useState(true);
    const [deploymentData, setDeploymentData] = useState([]);
    const [customScriptData, setCustomScriptData] = useState({});

    useEffect(() => {
        async function fetchData() {
            const response = await getIntegrationsData();

            const { deployment } = response;

            const deploymentAvailable = deployment.filter(
                (item) => item.available === true
            );

            const customScript = deployment.filter(
                (item) => item.key === 'custom_script'
            );

            setDeploymentData(deploymentAvailable);
            setCustomScriptData(customScript[0]);
        }
        fetchData();
    }, []);

    return (
        <Flex
            alignItems="center"
            data-testid="onboardingDeployAgentSelectStep"
            flexDirection="column"
            mt={4}
            mx="4%"
        >
            <Text
                fontSize={['32px', '32px', '32px', 5]}
                color={theme.palette.onboarding.titleTextColor}
                fontWeight="600"
                textAlign="center"
            >
                {t('Onboarding.deployAgentSelectStep.title')}
            </Text>
            <Flex flexDirection="column" mt="8%">
                <Text
                    color={theme.palette.text.primary}
                    fontSize={[3, 3, 3, 4]}
                    mb="4%"
                >
                    {t('Onboarding.deployAgentSelectStep.intro1')}
                </Text>
                <Text
                    color={theme.palette.text.primary}
                    fontSize={[3, 3, 3, 4]}
                    mb="4%"
                >
                    {t('Onboarding.deployAgentSelectStep.intro2')}
                </Text>
                <Text
                    color={theme.palette.onboarding.cardBodyText}
                    fontSize={[3, 3, 3, 4]}
                    fontWeight={600}
                    mb="4%"
                >
                    {t('Onboarding.deployAgentSelectStep.intro3')}
                </Text>
            </Flex>
            <Box
                backgroundColor={
                    theme.palette.onboarding.backgroundColorSecondary
                }
                p={3}
                width="100%"
                mt={3}
            >
                <Flex>
                    <Box alignItems="center" mr={5} display="flex">
                        <Text>
                            {t('Onboarding.deployAgentSelectStep.rmmQuestion')}
                        </Text>
                        <TooltipQ
                            text={t(
                                'Onboarding.deployAgentSelectStep.rmmQuestion.tooltip'
                            )}
                            size={FontSizes[1]}
                        />
                    </Box>
                    <InputRadio
                        mr={4}
                        alignItems="center"
                        name="hasRMM"
                        checked={hasRMM}
                        onChange={() => setHasRMM(true)}
                    >
                        {t('Common.yes')}
                    </InputRadio>
                    <InputRadio
                        alignItems="center"
                        name="hasRMM"
                        checked={!hasRMM}
                        onChange={() => setHasRMM(false)}
                    >
                        {t('Common.no')}
                    </InputRadio>
                </Flex>
            </Box>

            <Grid container spacing={3} mt="8px">
                {hasRMM ? (
                    deploymentData.map((integration) => (
                        <IntegrationCard
                            integration={integration}
                            key={`renderIntegration_${integration.application}`}
                            onboarding
                        />
                    ))
                ) : (
                    <IntegrationCard
                        integration={customScriptData}
                        key="renderIntegration_customScript"
                        onboarding
                    />
                )}
            </Grid>
        </Flex>
    );
};
